require('../../modules/es.object.is');

module.exports = require('../../internals/path').Object.is;
